import { useEffect } from 'react';

import Cookies from 'js-cookie';

import { hostIncludesDeLocale } from '../utils/countryHelper';

export const useEnvProxyForLocale = () => {
  useEffect(() => {
    if (window.location.hostname !== 'localhost') return;

    const proxyTarget = import.meta.env.VITE_PROXY_TARGET;
    if (hostIncludesDeLocale(proxyTarget)) {
      Cookies.set('locale', 'de');
    } else {
      Cookies.remove('locale');
    }
  }, []);
};
